import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute, Link } from '@tanstack/react-router';
import { Button } from '@upme/ui/components/button';
import { canEditGlobalCatalog } from '../../../features/auth/admin-capabilities';
import { useAuth } from '../../../features/auth/auth-context';
import { EventCategoriesTable } from '../../../features/event-categories/components/event-categories-table';
import { listEventCategoriesOptions } from '../../../features/event-categories/queries';
import { PageHeader } from '../../../shared/components/page-header';

export const Route = createFileRoute('/_authenticated/event-categories/')({
  loader: ({ context }) => context.queryClient.ensureQueryData(listEventCategoriesOptions()),
  component: EventCategoriesIndexPage,
});

function EventCategoriesIndexPage() {
  const { data: categories } = useSuspenseQuery(listEventCategoriesOptions());
  const { adminRoles } = useAuth();
  const canEdit = canEditGlobalCatalog(adminRoles);
  return (
    <div>
      <PageHeader
        title="Категории событий"
        description="Справочник категорий, к которым привязываются мероприятия."
        actions={
          canEdit ? (
            <Button asChild>
              <Link to="/event-categories/new">Новая категория</Link>
            </Button>
          ) : null
        }
      />
      {!canEdit && (
        <p className="text-sm text-muted-foreground mb-4">Редактировать категории может только SUPERADMIN.</p>
      )}
      <EventCategoriesTable categories={categories} />
    </div>
  );
}
